/**
 * Local platform-branding assets, served from the frontend's own public/
 * directory (not the @stw/types CDN constants, which are also written to
 * the database as persisted defaults and can't simply be repointed here).
 */

/** Header logo and embed watermark. Kept as SVG (pure frontend rendering,
 * no DB persistence) — the raster assets don't include a tightly-cropped
 * version of this horizontal lockup, and shrinking DEFAULT_THUMBNAIL.jpg
 * to header height renders it as an illegible white smear. */
export const PLATFORM_LOGO_URL = '/CityU_Cornell_Horiz_Logo_CMYK.svg';

/** Default fallback for missing user avatars — square PNG, crops cleanly
 * under `object-cover` circles. */
export const PLATFORM_MARK_URL = '/CITYU_WHITE_BG.png';

/** Default fallback for missing item thumbnails — 16:9 JPG matching the
 * aspect-video thumbnail frames it's rendered into. */
export const PLATFORM_THUMBNAIL_URL = '/DEFAULT_THUMBNAIL.jpg';

/** Large standalone logo mark on light backgrounds (error page, unsubscribe
 * page) — transparent PNG, unlike PLATFORM_MARK_URL's solid-white-background
 * version made for cropping into small circular avatars. */
export const PLATFORM_MARK_TRANSPARENT_URL = '/CITYU_TRANSPARENT_BG.png';
